"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.addEmployeeSwaggerMetadata = addEmployeeSwaggerMetadata;
exports.getEmployeesSwaggerMetadata = getEmployeesSwaggerMetadata;
exports.getEmployeeByIdSwaggerMetadata = getEmployeeByIdSwaggerMetadata;
exports.getEmployeeHierarchySwaggerMetadata = getEmployeeHierarchySwaggerMetadata;
exports.updateEmployeeSwaggerMetadata = updateEmployeeSwaggerMetadata;
exports.deleteEmployeeSwaggerMetadata = deleteEmployeeSwaggerMetadata;
exports.getListOfEmployeesValuesSwaggerMetadata = getListOfEmployeesValuesSwaggerMetadata;
exports.rebuildHierarchySwaggerMetadata = rebuildHierarchySwaggerMetadata;
const common_1 = require("@nestjs/common");
const swagger_1 = require("@nestjs/swagger");
const create_employee_dto_1 = require("./dto/create-employee.dto");
const get_employee_dto_1 = require("./dto/get-employee.dto");
const get_empolyees_query_dto_1 = require("./dto/get-empolyees-query.dto");
const messages_1 = require("../../../../../../libs/service-lib/src/lib/messages");
function addEmployeeSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_employee_dto_1.CreateEmployeeDto, get_employee_dto_1.EmployeeResponseDto), (0, swagger_1.ApiOperation)({
        summary: "Add a new employee",
        description: "Creates a new employee with the provided details.",
    }), (0, swagger_1.ApiBody)({
        description: "Details of the employee to be created.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_employee_dto_1.CreateEmployeeDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 201,
        description: messages_1.successMessage.employeeCreation,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 201 },
                message: { type: "string", example: messages_1.successMessage.employeeCreation },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(get_employee_dto_1.EmployeeResponseDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Bad Request" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function getEmployeesSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(get_empolyees_query_dto_1.GetEmployeesDto, get_employee_dto_1.EmployeeResponseDto), (0, swagger_1.ApiOperation)({
        summary: "Get all employees",
        description: "Fetches all employees with optional search, sorting, and pagination.",
    }), (0, swagger_1.ApiQuery)({
        name: "page",
        required: false,
        example: 1,
        description: "Page number for pagination (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "limit",
        required: false,
        example: 10,
        description: "Number of records per page (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "search",
        required: false,
        example: "John",
        description: "Search term to filter results (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "sort",
        required: false,
        example: "firstName:ASC",
        description: "Sorting criteria (optional).",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.employeeListRetrieval,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.employeeListRetrieval,
                },
                data: {
                    type: "array",
                    items: { $ref: (0, swagger_1.getSchemaPath)(get_employee_dto_1.EmployeeResponseDto) },
                },
                count: { type: "number", example: 100 },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.infoMessages.noEmployees,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.infoMessages.noEmployees },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function getEmployeeByIdSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(get_employee_dto_1.EmployeeResponseDto), (0, swagger_1.ApiOperation)({
        summary: "Get an employee by ID",
        description: "Retrieves details of a specific employee by their ID.",
    }), (0, swagger_1.ApiParam)({
        name: "employeeId",
        required: true,
        example: 1,
        description: "The ID of the employee to retrieve.",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.employeeRetrieval,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.employeeRetrieval,
                },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(get_employee_dto_1.EmployeeResponseDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.infoMessages.employeeNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.infoMessages.employeeNotFound },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function getEmployeeHierarchySwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Get employee hierarchy by root User ID",
        description: "Retrieves the organizational hierarchy starting from the given root User ID.",
    }), (0, swagger_1.ApiParam)({
        name: "userId",
        required: true,
        example: 1,
        description: "The User ID of the root employee for the hierarchy.",
        type: "number",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.employeeHierarchyRetrieval,
        // Define a schema for your hierarchy data if you have one,
        // otherwise, a generic object or array example.
        schema: {
            type: "object", // Or 'array' depending on your hierarchy structure
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.employeeHierarchyRetrieval,
                },
                data: {
                    type: "object", // Or 'array'
                    example: { message: "Hierarchy data for userId 1 (to be implemented)" },
                    description: "The employee hierarchy data.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.infoMessages.employeeHierarchyNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: {
                    type: "string",
                    example: messages_1.infoMessages.employeeHierarchyNotFound,
                },
            },
        },
    }), 
    // Add other common error responses like 500 if needed
    (0, swagger_1.ApiResponse)({ status: 500, description: "Internal server error." }));
}
function updateEmployeeSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(create_employee_dto_1.CreateEmployeeDto, get_employee_dto_1.EmployeeResponseDto), (0, swagger_1.ApiOperation)({
        summary: "Update an employee",
        description: "Updates the details of an existing employee.",
    }), (0, swagger_1.ApiParam)({
        name: "employeeId",
        required: true,
        example: 1,
        description: "The ID of the employee to update.",
    }), (0, swagger_1.ApiBody)({
        description: "Details of the employee to be updated.",
        schema: {
            $ref: (0, swagger_1.getSchemaPath)(create_employee_dto_1.CreateEmployeeDto),
        },
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.employeeUpdate,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.employeeUpdate },
                data: {
                    $ref: (0, swagger_1.getSchemaPath)(get_employee_dto_1.EmployeeResponseDto),
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.infoMessages.employeeNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.infoMessages.employeeNotFound },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 400,
        description: "Invalid input data.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 400 },
                message: { type: "string", example: "Bad Request Exception" },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function deleteEmployeeSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Delete an employee",
        description: "Deletes an employee by their ID.",
    }), (0, swagger_1.ApiParam)({
        name: "employeeId",
        required: true,
        example: 1,
        description: "The ID of the employee to delete.",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.employeeDeletion,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: { type: "string", example: messages_1.successMessage.employeeDeletion },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.infoMessages.employeeNotFound,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.infoMessages.employeeNotFound },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function getListOfEmployeesValuesSwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiExtraModels)(get_empolyees_query_dto_1.GetEmployeesDto, get_employee_dto_1.EmployeeResponseDto), (0, swagger_1.ApiOperation)({
        summary: "Get a lightweight list of employees",
        description: "Retrieves a list of employees with limited fields for dropdown or lightweight use cases. Supports pagination, sorting, and search.",
    }), (0, swagger_1.ApiQuery)({
        name: "page",
        required: false,
        example: 1,
        description: "Page number for pagination (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "limit",
        required: false,
        example: 10,
        description: "Number of records per page (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "search",
        required: false,
        example: "John",
        description: "Search term to filter results (optional).",
    }), (0, swagger_1.ApiQuery)({
        name: "sort",
        required: false,
        example: "firstName:ASC",
        description: "Sorting criteria (optional).",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: messages_1.successMessage.employeeListRetrieval,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: messages_1.successMessage.employeeListRetrieval,
                },
                data: {
                    type: "array",
                    items: { $ref: (0, swagger_1.getSchemaPath)(get_employee_dto_1.EmployeeResponseDto) },
                },
                count: { type: "number", example: 100 },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 404,
        description: messages_1.infoMessages.noEmployees,
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 404 },
                message: { type: "string", example: messages_1.infoMessages.noEmployees },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: { type: "string", example: "Internal server error." },
            },
        },
    }));
}
function rebuildHierarchySwaggerMetadata() {
    return (0, common_1.applyDecorators)((0, swagger_1.ApiBearerAuth)("access-token"), (0, swagger_1.ApiOperation)({
        summary: "Rebuild employee hierarchy",
        description: "Triggers a full rebuild of the employee_hierarchy table. This can be a long-running operation.",
    }), (0, swagger_1.ApiResponse)({
        status: 200,
        description: "Employee hierarchy rebuild process initiated successfully.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 200 },
                message: {
                    type: "string",
                    example: "Employee hierarchy rebuild process initiated successfully.",
                },
            },
        },
    }), (0, swagger_1.ApiResponse)({
        status: 500,
        description: "Internal server error during hierarchy rebuild.",
        schema: {
            type: "object",
            properties: {
                statusCode: { type: "number", example: 500 },
                message: {
                    type: "string",
                    example: "Failed to rebuild employee hierarchy",
                },
            },
        },
    }));
}
